import React from "react";

function EditUser() {
  return <div>This is Edit user</div>;
}

export default EditUser;
